(function () {
  function clampPercent(value) {
    var n = Number(value);
    if (Number.isNaN(n)) n = 50;
    return Math.max(0, Math.min(100, n));
  }

  function initOne(container) {
    var range = container.querySelector('.comparison-range');
    var afterLayer = container.querySelector('.comparison-image-after');
    var line = container.querySelector('.comparison-slider-line');
    var handle = container.querySelector('.comparison-slider-handle');

    if (!range || !afterLayer || !line || !handle) return;

    function update(value) {
      var v = clampPercent(value);
      afterLayer.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      line.style.left = v + '%';
      handle.style.left = v + '%';
    }

    function updateFromClientX(clientX) {
      var rect = container.getBoundingClientRect();
      if (!rect.width) return;

      var percent = ((clientX - rect.left) / rect.width) * 100;
      percent = clampPercent(percent);
      range.value = String(percent);
      update(percent);
    }

    range.addEventListener('input', function () {
      update(range.value);
    });

    if (window.PointerEvent) {
      var dragging = false;

      container.addEventListener('pointerdown', function (event) {
        dragging = true;
        try {
          container.setPointerCapture(event.pointerId);
        } catch (_) {}
        updateFromClientX(event.clientX);
      });

      container.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        updateFromClientX(event.clientX);
      });

      container.addEventListener('pointerup', function () {
        dragging = false;
      });

      container.addEventListener('pointercancel', function () {
        dragging = false;
      });
    } else {
      var fallbackDragging = false;

      container.addEventListener('mousedown', function (event) {
        fallbackDragging = true;
        updateFromClientX(event.clientX);
      });

      document.addEventListener('mousemove', function (event) {
        if (!fallbackDragging) return;
        updateFromClientX(event.clientX);
      });

      document.addEventListener('mouseup', function () {
        fallbackDragging = false;
      });

      container.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || !event.touches[0]) return;
          fallbackDragging = true;
          updateFromClientX(event.touches[0].clientX);
        },
        { passive: true }
      );

      document.addEventListener(
        'touchmove',
        function (event) {
          if (!fallbackDragging) return;
          if (!event.touches || !event.touches[0]) return;
          updateFromClientX(event.touches[0].clientX);
        },
        { passive: true }
      );

      document.addEventListener('touchend', function () {
        fallbackDragging = false;
      });

      document.addEventListener('touchcancel', function () {
        fallbackDragging = false;
      });
    }

    range.addEventListener('keydown', function (event) {
      var value = parseInt(range.value || '50', 10);
      if (Number.isNaN(value)) value = 50;

      if (event.key === 'ArrowLeft') {
        value = Math.max(0, value - 2);
      } else if (event.key === 'ArrowRight') {
        value = Math.min(100, value + 2);
      } else {
        return;
      }

      range.value = String(value);
      update(value);
      event.preventDefault();
    });

    update(range.value || container.dataset.startPosition || 50);
  }

  function initComparisonSliders(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('.comparison-container');

    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      if (container.dataset && container.dataset.comparisonInit === '1') continue;
      if (container.dataset) container.dataset.comparisonInit = '1';
      initOne(container);
    }
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  window.initComparisonSliders = initComparisonSliders;

  onReady(function () {
    initComparisonSliders(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initComparisonSliders(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initComparisonSliders(event.target);
  });
})();
